/* Geeko TCG · comportamiento del tema (sin dependencias) */
(function () {
  'use strict';

  /* ---------- Menú lateral móvil ---------- */
  function drawer() { return document.querySelector('[data-gk-drawer]'); }
  function openDrawer() { var d = drawer(); if (!d) return; d.hidden = false; document.body.classList.add('overflow-hidden'); }
  function closeDrawer() { var d = drawer(); if (!d) return; d.hidden = true; document.body.classList.remove('overflow-hidden'); }

  /* ---------- Barra de avisos rotativa ---------- */
  var announceTimer;
  function initAnnounce() {
    clearInterval(announceTimer);
    var box = document.querySelector('[data-gk-announce]');
    if (!box) return;
    var items = box.querySelectorAll('.gk-announce__item');
    if (items.length < 2) return;
    var i = 0;
    announceTimer = setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4000);
  }

  /* ---------- Banner (slider) ---------- */
  function initHero(root) {
    (root || document).querySelectorAll('[data-gk-hero]').forEach(function (hero) {
      var track = hero.querySelector('[data-gk-hero-track]');
      var dots = hero.querySelectorAll('[data-gk-hero-dots] button');
      var slides = track.children;
      if (slides.length < 2) return;
      var timer;
      function current() { return Math.round(track.scrollLeft / track.clientWidth); }
      function go(n) { track.scrollTo({ left: n * track.clientWidth, behavior: 'smooth' }); }
      function mark() { var c = current(); dots.forEach(function (d, k) { d.classList.toggle('is-active', k === c); }); }
      track.addEventListener('scroll', function () { window.requestAnimationFrame(mark); }, { passive: true });
      dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); restart(); }); });
      function restart() {
        clearInterval(timer);
        if (hero.dataset.autoplay !== 'true') return;
        var ms = parseInt(hero.dataset.speed, 10) || 5000;
        timer = setInterval(function () { go((current() + 1) % slides.length); }, ms);
      }
      track.addEventListener('pointerdown', function () { clearInterval(timer); });
      track.addEventListener('pointerup', restart);
      restart();
    });
  }

  /* ---------- Carruseles de productos ---------- */
  function railStep(rail) { var item = rail.querySelector('.gk-rail__item'); return item ? (item.getBoundingClientRect().width + 10) * 2 : 300; }

  /* ---------- Tarjeta: elegir variante y añadir ---------- */
  function cardOf(el) { return el.closest('.gk-card'); }

  function selectPill(pill) {
    var card = cardOf(pill);
    card.querySelectorAll('[data-gk-pill]').forEach(function (p) { p.classList.remove('is-active'); });
    pill.classList.add('is-active');
    var add = card.querySelector('[data-gk-add]');
    if (add) add.dataset.id = pill.dataset.id;
    var price = card.querySelector('[data-gk-price]');
    if (price) price.textContent = pill.dataset.price;
    var was = card.querySelector('[data-gk-was]');
    if (was) { if (pill.dataset.was) { was.textContent = pill.dataset.was; was.hidden = false; } else { was.hidden = true; } }
  }

  function addToCart(btn) {
    if (btn.classList.contains('is-busy')) return;
    var drawerEl = document.querySelector('cart-drawer');
    var label = btn.innerHTML;
    var body = { id: parseInt(btn.dataset.id, 10), quantity: 1 };
    if (drawerEl && typeof drawerEl.getSectionsToRender === 'function') {
      body.sections = drawerEl.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    btn.classList.add('is-busy');
    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state.status || state.errors) { throw new Error(state.description || state.message || 'error'); }
        btn.classList.remove('is-busy');
        btn.classList.add('is-done');
        btn.innerHTML = '✓ Añadido';
        setTimeout(function () { btn.classList.remove('is-done'); btn.innerHTML = label; }, 1600);
        if (drawerEl && typeof drawerEl.renderContents === 'function' && state.sections) {
          drawerEl.renderContents(state);
        } else {
          window.location.href = window.routes.cart_url;
        }
      })
      .catch(function () {
        btn.classList.remove('is-busy');
        btn.innerHTML = 'Sin stock';
        setTimeout(function () { btn.innerHTML = label; }, 1800);
      });
  }

  /* ---------- Eventos delegados ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var el;
    if ((el = t.closest('[data-gk-open]'))) { openDrawer(); return; }
    if (t.closest('[data-gk-close]')) { closeDrawer(); return; }
    if ((el = t.closest('[data-gk-pill]'))) { if (!el.disabled) selectPill(el); return; }
    if ((el = t.closest('[data-gk-add]'))) { addToCart(el); return; }
    if ((el = t.closest('[data-gk-prev]'))) { var r1 = el.closest('[data-gk-prods]').querySelector('[data-gk-rail]'); r1.scrollBy({ left: -railStep(r1), behavior: 'smooth' }); return; }
    if ((el = t.closest('[data-gk-next]'))) { var r2 = el.closest('[data-gk-prods]').querySelector('[data-gk-rail]'); r2.scrollBy({ left: railStep(r2), behavior: 'smooth' }); return; }
    // cerrar filtros al hacer clic fuera
    if (!t.closest('[data-gk-fgroup]')) {
      document.querySelectorAll('[data-gk-fgroup][open]').forEach(function (d) { d.removeAttribute('open'); });
    }
  });

  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-gk-sort]');
    if (!sel) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sel.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  // un solo filtro desplegado a la vez
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d.matches || !d.matches('[data-gk-fgroup]') || !d.open) return;
    document.querySelectorAll('[data-gk-fgroup][open]').forEach(function (o) { if (o !== d) o.removeAttribute('open'); });
  }, true);

  function init() { initAnnounce(); initHero(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
